import type { AxiosInstance } from 'axios'
import type { Tag } from '@/models/tag'

export class TagService {
  constructor(private instance: AxiosInstance) {}

  createTag = (name: string, namespace: string) =>
    this.instance
      .post<Tag>(`/tags`, { name, namespace })
      .then((response) => response.data)

  loadTags = (namespace: string) =>
    this.instance
      .get<Tag[]>(`/tags`, { params: { namespace } })
      .then((response) => response.data)
}
